import { type APIDocument, type APIProductModel } from '@visorpro/client'

export const requiredFields = [
    {
        label: 'Original Filename',
        key: 'original_filename',
        description: 'Filename matching string; matching with all alphanumeric characters ignoring case and file extension.',
        acceptableNames: ['name', 'item number', 'original filename', 'id', 'file name', 'filename'],
        required: true,
    },
    {
        label: 'SHA512 Hash',
        key: 'sha512_hash',
        description: 'SHA512 hash of the document; accepting the full hash or only the first 32 characters.',
        acceptableNames: ['sha512 hash', 'hash', 'sha', 'sha512'],
        required: true,
    },
    {
        label: 'Title',
        key: 'title',
        description: 'New document title to update.',
        acceptableNames: ['title', 'description'],
        required: true,
    },
    {
        label: 'Models',
        key: 'models',
        description: 'Product models associated with the document, separated by comma if multiple.',
        acceptableNames: ['model', 'models'],
        required: true,
    },
    {
        label: 'Manual Type',
        key: 'type',
        description: 'Service, Operators, etc.',
        acceptableNames: ['manual type', 'type'],
        required: true,
    },
    // { label: "Serial Number", key: "serial_number", description: "Product serial number", acceptableNames: ["serial number", "serial"], required: false },
    // { label: "Release Date", key: "release_date", description: "Document release date", acceptableNames: ["release date", "date"], required: false },
] as const

export type RequiredFieldKey = (typeof requiredFields)[number]['key']
export type ColumnMapping = Record<RequiredFieldKey, string>

export interface ProductModelMatching {
    name: string
    results: Fuzzysort.KeyResults<APIProductModel>
    selected:
    | Fuzzysort.KeyResult<APIProductModel>
    | typeof CREATE_NEW_MODEL
    | typeof IGNORE_MODEL
    product_model: APIProductModel | null
}

export const CREATE_NEW_MODEL = 'CREATE_NEW_MODEL'
export const IGNORE_MODEL = 'IGNORE_MODEL'

export interface DocumentUpdate {
    original_filename: string
    sha512_hash: string
    old: APIDocument
    new?: APIDocument
}

export interface ProductModelUpdate {
    model_id: string
    adding_document_ids: string[]
    deleting_document_ids: string[]
}
